import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/home/page";
import ServiceDetail from "@/pages/service/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/hizmetler/:slug",
        element: <ServiceDetail />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;